"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Components_1 = __importDefault(require("./Components"));
var react_redux_1 = require("react-redux");
var config_1 = __importDefault(require("Utils/redux/config"));
var rootId = document.getElementById("root");
var logger = function () {
    return console.log(config_1.default.getState(), "root logger: log for intial store: in <App />");
};
var render = function () {
    logger();
    react_dom_1.default.render(react_1.default.createElement(react_redux_1.Provider, { store: config_1.default },
        react_1.default.createElement(Components_1.default, null)), rootId);
};
render();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLHdEQUFpQztBQUVqQyw0REFBK0I7QUFFL0IsMkNBQXVDO0FBRXZDLDhEQUF1QztBQUl2QyxJQUFNLE1BQU0sR0FBRyxRQUFRLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0FBQy9DLElBQU0sTUFBTSxHQUFHO0lBQ2IsT0FBQSxPQUFPLENBQUMsR0FBRyxDQUNULGdCQUFLLENBQUMsUUFBUSxFQUFFLEVBQ2hCLCtDQUErQyxDQUNoRDtBQUhELENBR0MsQ0FBQztBQUlKLElBQU0sTUFBTSxHQUFHO0lBQ2IsTUFBTSxFQUFFLENBQUM7SUFDVCxtQkFBUSxDQUFDLE1BQU0sQ0FDYiw4QkFBQyxzQkFBUSxJQUFDLEtBQUssRUFBRSxnQkFBSztRQUNwQiw4QkFBQyxvQkFBRyxPQUFHLENBQ0UsRUFDWCxNQUFNLENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLE1BQU0sRUFBRSxDQUFDIn0=